import { colors } from "#app/theme/v1/colors";
import { fontSizes } from "#app/theme/v1/fontSizes";
import { Alert } from "#shared/view/components/Alert";
import { Flex } from "#shared/view/components/Flex";
import { UnstyledButton } from "#shared/view/designSystem/UnstyledButton";

type Props = {
  onClick: () => void;
  label: string;
  cta: string;
};

export const PredictionInputErrorState = ({ onClick, label, cta }: Props) => {
  return (
    <Alert variant="light" color="red" title="" p={8}>
      <Flex dir="row" align="center" gap="8px">
        <span
          style={{
            height: 8,
            width: 8,
            borderRadius: "100%",
            backgroundColor: "red",
            display: "block",
          }}
        />
        {label}
        <UnstyledButton
          color="dimmed"
          style={{
            textDecoration: "underline",
            color: colors.gray[7],
            fontSize: fontSizes.small,
          }}
          onClick={onClick}
        >
          {cta}
        </UnstyledButton>
      </Flex>
    </Alert>
  );
};
